import React from "react";
import { useTranslation } from "react-i18next";
import NavItem from "src/components/layout/LayoutStudent/NavItem/NavItem";
import useTenant from "src/hooks/api/services/tenants/useTenant";
import useAuth from "src/hooks/selectors/useAuth";
import useWindowSize from "src/hooks/useWindowSize";
import { getEmployeeUrl } from "src/lib/urls";

const NavItems = () => {
	const { t } = useTranslation("layout", {
		keyPrefix: "nav-items",
	});
	const { tenant } = useTenant();
	const auth = useAuth();
	const type = auth.type;
	const { isPhone } = useWindowSize();
	const isEmployee = auth.is_admin || auth.is_sales;
	return (
		<div className="">
			<strong className="block font-bold mb-3">Menu</strong>
			<div className="flex flex-col gap-4">
				<NavItem
					className={`gtm-${type}-dashboard-sidebar--link-dashboard`}
					icon="fas fa-user"
					to="/dashboard"
				>
					{t("my-profile")}
				</NavItem>
				{tenant?.slug === "getjobsdone" && (
					<NavItem
						className={`gtm-${type}-dashboard-sidebar--link-opdracht-zoeken`}
						icon="fas fa-search"
						to={tenant?.urls?.public + "/opdrachten/alles/overal"}
					>
						{t("search-tasks")}
					</NavItem>
				)}
				{tenant?.slug === "getcrewdone" && (
					<NavItem
						className={`gtm-${type}-dashboard-sidebar--link-opdracht-zoeken`}
						icon="fas fa-search"
						to={tenant?.urls?.public + "/evenementen"}
					>
						{t("search-tasks")}
					</NavItem>
				)}
				<NavItem
					className={`gtm-${type}-dashboard-sidebar--link-opdrachten`}
					icon="fas fa-clock"
					to="/tasks"
					count={auth.unreads?.tasks}
				>
					{t("my-tasks")}
				</NavItem>
				{tenant.modules.includes("hour-validation") && (
					<NavItem
						to="/hours"
						icon="fas fa-alarm-clock"
						count={auth?.unreads?.hours}
					>
						{t("my-hours")}
					</NavItem>
				)}
				{tenant.modules.includes("talentboard") && (
					<NavItem
						className={`gtm-${type}-dashboard-sidebar--link-aanbod`}
						icon="fas fa-list"
						to="/offers"
						count={auth?.unreads?.offers}
					>
						{t("my-offers")}
					</NavItem>
				)}
				<NavItem
					icon="fas fa-comments"
					to="/inbox"
					count={auth?.unreads?.messages}
				>
					{t("messages")}
				</NavItem>
				{tenant.modules.includes("student-pool") && (
					<NavItem
						className={`gtm-${type}-dashboard-sidebar--link-mijn-netwerk`}
						icon="fas fa-users"
						to="/network"
						count={auth?.unread_invites}
					>
						{t("my-network")}
					</NavItem>
				)}
				<NavItem
					className={`gtm-${type}-dashboard-sidebar--link-mijn-betalingen`}
					icon="fas fa-credit-card"
					to="/payments"
				>
					{t("my-payments")}
				</NavItem>
			</div>
			{!isPhone ? (
				<>
					<strong className="block font-bold mb-3 mt-8">
						{t("links")}
					</strong>
					<div className="flex flex-col gap-4">
						<NavItem
							icon="fas fa-info-square"
							to={tenant?.urls?.public + "/veelgestelde-vragen"}
						>
							{t("faq")}
						</NavItem>
						<NavItem
							icon="fas fa-envelope"
							to={tenant?.urls?.public + "/contact"}
						>
							{t("contact")}
						</NavItem>
					</div>
				</>
			) : (
				false
			)}
			{isEmployee && process.env.NODE_ENV !== "development" ? (
				<>
					<strong className="block font-bold mb-3 mt-8">
						Admin links
					</strong>
					<div className="flex flex-col gap-4">
						<NavItem icon="fas fa-lock" to={getEmployeeUrl("/")}>
							Werknemer omgeving
						</NavItem>
						{auth.is_admin ? (
							<NavItem icon="fas fa-lock" to={"/portal/home"}>
								Oude portal
							</NavItem>
						) : (
							false
						)}
					</div>
				</>
			) : (
				false
			)}
		</div>
	);
};

export default NavItems;
